import Report from "report"
import TableReportHelper from "report/helper"

export default class ListaPresencaReport extends Report {
    constructor(obj) {
        super()

        this.obj = obj
        this.inscricoes = obj.inscricoes
    }

    get title() {
        return "Lista de Presença"
    }

    get fileName() {
        return this.title
    }

    static renderListaPresencaAvulsa(index) {
        const h = new TableReportHelper({})
        let inscricaoContent = []
        const lineStyle = index % 2 === 0 ? "cellValor" : "whiteCellValor"

        inscricaoContent.push(
            h.row(
                h.text(`${index + 1}`, { cellStyle: lineStyle }),
                h.text('', { cellStyle: lineStyle }),
                h.text('', { cellStyle: lineStyle }),
                h.text('', { cellStyle: lineStyle }),
                h.text('', { cellStyle: lineStyle }),
                h.text('', { cellStyle: lineStyle }),
            )
        )

        const content = [
            h.panel(inscricaoContent, { widths: [15, 80, 80, 80, 65, "*",] })
        ]

        return content
    }

    static renderListaPresenca(participante, index) {
        const h = new TableReportHelper({ participante });
        let inscricaoContent = [];
        const lineStyle = index % 2 === 0 ? "cellValor" : "whiteCellValor"

        inscricaoContent.push(
            h.row(
                h.text(`${index + 1}`, { cellStyle: lineStyle }),
                h.text(
                    participante.empresa.funcionarios.nomeCracha
                        ? participante.empresa.funcionarios.nomeCracha
                        : participante.empresa.funcionarios.nomeParticipante
                    , { cellStyle: lineStyle }
                ),
                h.text(participante.empresa.nomeEmpresaCracha, { cellStyle: lineStyle }),
                h.text(participante.municipio, { cellStyle: lineStyle }),
                h.text('Sim (  )  Não (  )', { cellStyle: lineStyle }),
                h.text('', { cellStyle: lineStyle }),
            )
        )

        const content = [
            h.panel(inscricaoContent, { widths: [15, 160, 160, 160, 65, "*",] })
        ]

        return content
    }

    async render() {
        this.helper = new TableReportHelper(this.inscricoes)
        let content = []


        content.push(
            this.helper.panel(
                this.helper.row(
                    this.helper.title("Lei Geral de Proteção de Dados Pessoais - LGPD"),
                ),
                { widths: ["*"] }
            )
        )

        content.push(
            this.helper.panel(
                this.helper.row(
                    this.helper.text('Informo que os seus dados pessoais serão utilizados para o cumprimento de obrigações contratuais, legais e regulatórias do SEBRAE em razão de suas atividades, para a execução de seus Programas e prestação de serviços, para fomentar, desenvolver e melhorar soluções para empreendedores e pequenos negócios, para oferecer produtos e serviços que sejam do seu interesse, para realizar pesquisas com os clientes que foram atendidos pelo SEBRAE e para realizar a comunicação oficial pelo SEBRAE ou por seus prestadores de serviço, por telefone, e-mail, SMS, WhatsApp, etc, bem como autorizo o compartilhamento dos meus dados com entidades parceiras do SEBRAE e com consultores credenciados para as mesmas finalidade anteriormente especificadas. Caso você queira conhecer um pouco mais de como o SEBRAE trata os seus dados pessoais, você pode acessar o seu Portal em www.sebrae.com.br/lgpd, lá reunimos um conjunto de informações sobre como estamos atuando com os dados pessoais de nossos clientes, com foco em segurança e transparência. Política de privacidade: https://minio-cpe.sebrae.com.br/documento/politica-privacidade.pdf. Ao assinar o "ACEITE LGPD" Manifesto-me de forma informada, livre, expressa e consciente no sentido de autorizar o SISTEMA SEBRAE a realizar o tratamento de meus Dados Pessoais para as finalidades aqui estabelecidas.'),
                ),
                { widths: ["*"] }
            )
        )
        // Informo que os seus dados pessoais serão utilizados para o cumprimento de obrigações contratuais, legais e regulatórias do SEBRAE em razão de suas atividades, para a execução de seus Programas e prestação de serviços, para fomentar, desenvolver e melhorar soluções para empreendedores e pequenos negócios, para oferecer produtos e serviços que sejam do seu interesse, para realizar pesquisas com os clientes que foram atendidos pelo SEBRAE e para realizar a comunicação oficial pelo SEBRAE ou por seus prestadores de serviço, por telefone, e-mail, SMS, WhatsApp, etc, bem como autorizo o compartilhamento dos meus dados com entidades parceiras do SEBRAE e com consultores credenciados para as mesmas finalidade anteriormente especificadas. Caso você queira conhecer um pouco mais de como o SEBRAE trata os seus dados pessoais, você pode acessar o seu Portal em www.sebrae.com.br/lgpd, lá reunimos um conjunto de informações sobre como estamos atuando com os dados pessoais de nossos clientes, com foco em segurança e transparência. Política de privacidade: https://minio-cpe.sebrae.com.br/documento/politica-privacidade.pdf. Ao assinar o "ACEITE LGPD" Manifesto-me de forma informada, livre, expressa e consciente no sentido de autorizar o SISTEMA SEBRAE a realizar o tratamento de meus Dados Pessoais para as finalidades aqui estabelecidas.

        content.push(
            this.helper.panel(
                this.helper.row(
                    this.helper.title(""),
                    this.helper.title("Representante"),
                    this.helper.title("Empresa"),
                    this.helper.title("Município"),
                    this.helper.title("Aceite LGPD"),
                    this.helper.title("Assinatura"),
                ),
                { widths: [15, 160, 160, 160, 65, "*",] }
            )
        )
        this.inscricoes.forEach((inscricao, index) => {
            content.push(ListaPresencaReport.renderListaPresenca(inscricao, index))
        })

        for (let i = this.inscricoes.length; i < this.inscricoes.length + 10; i++) {
            content.push(ListaPresencaReport.renderListaPresencaAvulsa(i))
        }

        return content
    }
}
